/**
 * Vite DEV probe for admin PWA registration.
 * Isolated so Jest can map this module (no `import.meta` in the register file).
 */
export function isAdminPwaViteDev(): boolean {
  return import.meta.env.DEV;
}
